import { useMemo } from "react";
import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import MelhousNotice from "../Components/MelhousNotice";

function MelhousBoard({ model, notice }) {
  const currentView = useSignal("list");
  const layout = useMemo(() => model.ctxView(), [model]);
  return (
    <div className="w-full">
      {notice && (
        <div className="px-3 lg:px-4 pt-3">
          <MelhousNotice text={notice} />
        </div>
      )}
      <Board layout={layout} currentView={currentView} />
    </div>
  );
}

export default MelhousBoard;
